<template>  
  <VUEModal :Titolo="Titolo" 
            :Programma="'DMSEW'"
            :Altezza="AppaionoAllineamenti() ? (parseInt(AltezzaPopup) + 80) + 'px' : AltezzaPopup" 
            :Larghezza="'900px'" 
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            @onClickChiudiModal="OnClickChiudiModal">

    <template v-slot:Body>
      <VUEPopupDataAllineamento  v-if="PopupAllineamentoInclinazioni"
                                :ChiaveSito="ObjCatena.DatiCatena.CHIAVE_SITO"
                                @onClickConfermaAllineamento="OnClickConfermaAllineamento"
                                @onClickAnnullaPopupAllineamento="OnClickAnnullaAllineamento"/>

      <VUEPopupDataAllineamento  v-if="PopupAllineamentoTemp"
                                :ChiaveSito="ObjCatena.DatiCatena.CHIAVE_SITO"
                                @onClickConfermaAllineamento="OnClickConfermaAllineamentoTemp"
                                @onClickAnnullaPopupAllineamento="OnClickAnnullaAllineamentoTemp"/>

      <VUEPopupDataAllineamento  v-if="PopupAllineamentoDeformazioni"
                                :ChiaveSito="ObjCatena.DatiCatena.CHIAVE_SITO"
                                @onClickConfermaAllineamento="OnClickConfermaAllineamentoDeformazioni"
                                @onClickAnnullaPopupAllineamento="OnClickAnnullaAllineamentoDeformazioni"/>

      <VUEModal v-if="PopupFiltroProfondita" :Titolo="this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_INT_TITOLO',this.LinguaUtente)" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'" :Altezza="'150px'" :Larghezza="'500px'"
                @onClickChiudiModal="AnnullaFiltroProfondita">
        <template v-slot:Body>
          <div style="float: left;font-size:14px;text-align: center;">
            <label>{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_INT_PROF_TESTO',this.LinguaUtente) }}:</label>
          </div>
          <div style="clear:both;height:4px"></div>
          <div style="clear:both;height:4px"></div>
          <div class="ZMDivPopupContent" style="width: 100%">
            <label class="ZMLabelDescriptionPopup">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_INT_PROF_MIN',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div> 
            <input class="form-control" type="number" style="float: left; width: calc(50% - 20px)" v-model="Filtro.DallaProfondita">
          </div>
          <div style="clear:both;height:4px"></div>
          <div class="ZMDivPopupContent" style="width: 100%">
            <label class="ZMLabelDescriptionPopup">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_INT_PROF_MAX',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div> 
            <input class="form-control" type="number" style="float: left; width: calc(50% - 20px)" v-model="Filtro.AllaProfondita">
          </div>
        </template>
        <template v-slot:Footer>
          <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:20%" @click="AnnullaFiltroProfondita" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
          <button v-if="(Filtro.DallaProfondita !== '') && (Filtro.AllaProfondita !== '')" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:20%" @click="ConfermaFiltroProfondita" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
        </template>
      </VUEModal>

      <div class="col-md-12">
        <div style="float:right;width:3%;">&nbsp;</div>

        <div style="float:right;width:8%">
          <select class="form-control" v-model="Filtro.OreAl">
          <option v-for="Ora in 24" 
                    :Key="Ora">{{ Ora -1 }}</option>  
          </select>
        </div> 
        <div style="float: right;font-size:14px;padding-top: 5px;width:4%;text-align: right; padding-right: 15px;min-width:103px">
          <label>{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE_M',this.LinguaUtente) }}</label>
        </div>

        <div style="float:right;width:9%">
          <input type="date" class="form-control" style="min-width:132px" v-model="Filtro.AllaData"/>
        </div>
        <div style="float: right;font-size:14px;padding-top: 5px;width:7%;text-align: right; padding-right: 15px;">
          <label style="float:left;min-width:20px;width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_AL',this.LinguaUtente) }}</label>
        </div>
        <div style="float:right;width:8%">
          <select class="form-control" v-model="Filtro.OreDal">
          <option v-for="Ora in 24" 
                    :Key="Ora">{{ Ora - 1 }}</option>  
          </select>
        </div> 
        <div style="float: right;font-size:14px;padding-top: 5px;width:7%;text-align: right; padding-right: 15px;min-width:103px">
          <label>{{ this.GetTraduzioneLabel('UdmGenerali','TKN_ORE_M',this.LinguaUtente) }}</label>
        </div>

        <div style="float:right;width:9%">
          <input type="date" class="form-control" style="min-width:132px" v-model="Filtro.DallaData"/>
        </div>
        <div style="float: right;font-size:14px;padding-top: 5px;width:11%;text-align: right; padding-right: 15px;min-width:30px">
          <label>{{ this.GetTraduzioneLabel('Generic','TKN_STORICO_DAL',this.LinguaUtente) }}</label>
        </div>
        <div style="float:right;width:3%;">&nbsp;</div>
        <div style="clear:both;height:10px"></div>
      </div>



      <div class="col-md-12">
        <div style="float:left;width:3%;">&nbsp;</div>

        <div style="width:57%;float:left;">
          <div class="ZMSeparatoreScheda" style="margin-bottom:0px;margin-top:0px" :style="{'background-color' : ColoriPantone.Marrone }">
            <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('Generic','TKN_MODULI',this.LinguaUtente) }}</text>
          </div>
          <div style="overflow:auto" :style="{'max-height': AppaionoAllineamenti() ? (parseInt(AltezzaPopup) - 20) + 'px' : (parseInt(AltezzaPopup) - 100) + 'px'}" >
            <template v-for="(OggettoModulo, index) in FiltraModuli" :key="index">
              <!-- <div style="" :style="{'background-color' : index % 2 == 0? ColoriSfondo.Arancione : 'white' }"> -->
              <div style="background-color:white;">
                <div style="float:left;width:3%;">&nbsp;</div>
                <input class="form-control" style="float:left;width:3%;margin-top:4px;padding: 0px;height: 20px" type="checkbox" v-model="OggettoModulo.Selezionato"/>
                <div style="float:left;width:2%;">&nbsp;</div>
                <text style="float:left;width:92%;margin-top:2px;font-size:16px"> {{ this.GetTraduzioneLabel('Generic','TKN_MOD_N',this.LinguaUtente) }} {{ OggettoModulo.Id }}</text>
                <div style="clear:both"></div>
              </div>
            </template>
          </div>
        </div>
        
        <div style="float:left;width:2%;">&nbsp;</div>

        <div style="width:35%;float:left" ref="DivPulsanti">
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button @click="OnClickSelezionaTuttiModuli" type="button" class="btn btn-info" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_TUTTI',this.LinguaUtente) }}</button>
          </div>
          <div style="clear:both;height:4px"></div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button @click="OnClickDeselezionaTuttiModuli" type="button" class="btn btn-info" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_NESSUNO',this.LinguaUtente) }}</button>
          </div>
          <div style="clear:both;height:4px"></div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button @click="OnClickInvertiTuttiModuli" type="button" class="btn btn-info" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_INVERTI',this.LinguaUtente) }}</button>
          </div>
          <div style="clear:both;height:4px"></div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div v-if="!FiltroProfonditaAttivo" style="float:left;width:96%">
            <button @click="OnClickPopupFiltroProfondita" type="button" class="btn btn-info" style="width:100%">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_INT_PROF',this.LinguaUtente) }}</button>
          </div>
          <div v-else style="float:left;width:96%">
            <button @click="OnClickResetFiltroProfondita" type="button" class="btn btn-info" style="width:100%">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_RESET_PROF',this.LinguaUtente) }}</button>
          </div>
          <div style="clear:both;height:10px"></div>

          <div v-if="AppareCheckPiezometri()">
            <div style="float:left;width:4%;">&nbsp;</div>
            <div style="float:left;width:6%;">
              <input style="float:left;height:100%" type="checkbox" class="form-control" v-model="Filtro.Piezometri"/>
            </div> 
            <div style="float:left;width:90%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_PIEZOMETRI',this.LinguaUtente) }}</label>
            </div> 
            <div class="ZMDistanziatore"></div>
          </div>

          <div v-if="AppareCheckEstensimetri()">
            <div style="float:left;width:4%;">&nbsp;</div>
            <div style="float:left;width:6%;">
              <input style="float:left;height:100%" type="checkbox" class="form-control" v-model="Filtro.Estensimetri"/>
            </div> 
            <div style="float:left;width:90%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_ESTENSIMETRI',this.LinguaUtente) }}</label>
            </div> 
            <div class="ZMDistanziatore"></div>
          </div>

          <div class="col-md-12" style="float:right" v-if="AppaionoAllineamenti()">
            <div>

              <div style="width:100%;float:left">
                <div class="ZMSeparatoreScheda" style="margin-bottom:0px;margin-top:0px; border-radius: 2px;" :style="{'background-color' : ColoriPantone.Marrone }">       
                  <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_INCL',this.LinguaUtente) }}:</text>
                </div>
              </div>
              <div class="ZMDistanziatore"></div>

              <div style="width:100%;float:left" v-if="Filtro.AllineamentoIncl == null">
                <div style="margin-bottom:0px;margin-top:0px;text-align:center">  
                  <div class="ZMDistanziatore"></div>
                  <text style="font-weight: bold">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_INCL_NON_ASS',this.LinguaUtente) }}</text>
                  <div class="ZMDistanziatore"></div>
                </div>
              </div>
              <div style="width:100%;float:left" v-else>
                <div style="margin-bottom:0px;margin-top:0px;text-align:center">       
                  <text style="font-weight: bold">{{ GestisciDateGrafica(Filtro.AllineamentoIncl.DataAllineamento) + ' ' + Filtro.AllineamentoIncl.OrarioAllineamento }}</text>
                </div>
              </div>
              <div class="ZMDistanziatore"></div>

              <div style="width:100%;float:left">
                <div style="margin-bottom:0px;margin-top:0px;text-align:center">       
                  <button @click="OnClickCancellaAllineamentoInclinazioni" type="button" class="btn btn-info" style="float:right;font-weight:bold;width:25%;font-size: 10px;" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
                  <button @click="OnClickVisualizzaAllineamentoInclinazioniAllaData" type="button" class="btn btn-info" style="float:right;font-weight:bold;width:25%;font-size: 10px;margin-right:20px;" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CAMBIA',this.LinguaUtente) }}</button>
                </div>
              </div>
              <div class="ZMDistanziatore"></div>
            </div>

            <div>
              <div style="width:100%;float:left">
                <div class="ZMSeparatoreScheda" style="margin-bottom:0px;margin-top:0px; border-radius: 2px;" :style="{'background-color' : ColoriPantone.Marrone }">       
                  <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_TEMP',this.LinguaUtente) }}:</text>
                </div>
              </div>
              <div class="ZMDistanziatore"></div>

              <div style="width:100%;float:left" v-if="Filtro.AllineamentoTemp == null">
                <div style="margin-bottom:0px;margin-top:0px;text-align:center">
                  <div class="ZMDistanziatore"></div>       
                  <text style="font-weight: bold">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_TEMP_NON_ASS',this.LinguaUtente) }}</text>
                  <div class="ZMDistanziatore"></div>
                </div>
              </div>
              <div style="width:100%;float:left" v-else>
                <div style="margin-bottom:0px;margin-top:0px;text-align:center">       
                  <text style="font-weight: bold">{{ GestisciDateGrafica(Filtro.AllineamentoTemp.DataAllineamento) + ' ' + Filtro.AllineamentoTemp.OrarioAllineamento }}</text>
                </div>
              </div>
              <div class="ZMDistanziatore"></div>

              <div style="width:100%;float:left">
                <div style="margin-bottom:0px;margin-top:0px;text-align:center">       
                  <button @click="OnClickCancellaAllineamentoTemp" type="button" class="btn btn-info" style="float:right;font-weight:bold;width:25%;font-size: 10px;" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
                  <button @click="OnClickVisualizzaAllineamentoTempAllaData" type="button" class="btn btn-info" style="float:right;font-weight:bold;width:25%;font-size: 10px;margin-right:20px;" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CAMBIA',this.LinguaUtente) }}</button>
                </div>
              </div>
              <div class="ZMDistanziatore"></div>
            </div>

            <div>
              <div style="width:100%;float:left">
                <div class="ZMSeparatoreScheda" style="margin-bottom:0px;margin-top:0px; border-radius: 2px;" :style="{'background-color' : ColoriPantone.Marrone }">       
                  <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_DEF',this.LinguaUtente) }}:</text>
                </div>
              </div>
              <div class="ZMDistanziatore"></div>

              <div style="width:100%;float:left" v-if="Filtro.AllineamentoDef == null">
                <div style="margin-bottom:0px;margin-top:0px;text-align:center"> 
                  <div class="ZMDistanziatore"></div>      
                  <text style="font-weight: bold">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_DEF_NON_ASS',this.LinguaUtente) }}</text>
                  <div class="ZMDistanziatore"></div>
                </div>
              </div>
              <div style="width:100%;float:left" v-else>
                <div style="margin-bottom:0px;margin-top:0px;text-align:center">       
                  <text style="font-weight: bold">{{ GestisciDateGrafica(Filtro.AllineamentoDef.DataAllineamento) + ' ' + Filtro.AllineamentoDef.OrarioAllineamento }}</text>
                </div>
              </div>
              <div class="ZMDistanziatore"></div>

              <div style="width:100%;float:left">
                <div style="margin-bottom:0px;margin-top:0px;text-align:center">       
                  <button @click="OnClickCancellaAllineamentoDeformazioni" type="button" class="btn btn-info" style="float:right;font-weight:bold;width:25%;font-size: 10px;" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
                  <button @click="OnClickVisualizzaAllineamentoDeformazioniAllaData" type="button" class="btn btn-info" style="float:right;font-weight:bold;width:25%;font-size: 10px;margin-right:20px;" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CAMBIA',this.LinguaUtente) }}</button>
                </div>
              </div>
              <div class="ZMDistanziatore"></div>
            </div>
          </div>

          <div v-if="AppareCheckVisualizzaMarkup()">
            <div style="float:left;width:4%;">&nbsp;</div>
            <div style="float:left;width:6%;">
              <input style="float:left;height:100%" type="checkbox" class="form-control" v-model="Filtro.VisualizzaMarkup"/>
            </div> 
            <div style="float:left;width:90%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_MOSTRA_MARKUP',this.LinguaUtente) }}</label>
            </div> 
            <div class="ZMDistanziatore"></div>
          </div>

          <!-- <div v-if="AppareCheckInterpMinQuad()">
            <div style="float:left;width:4%;">&nbsp;</div>
            <div style="float:left;width:6%;">
              <input style="float:left;height:100%" type="checkbox" class="form-control" v-model="Filtro.InterpMinimiQuadrati"/>
            </div> 
            <div style="float:left;width:90%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;Interp. minimi quadrati</label>
            </div> 
            <div class="ZMDistanziatore"></div>
          </div> -->

          <div v-if="AppareOrientamentoAsse()">
            <div style="float:left;width:4%;">&nbsp;</div>
            <div style="float:left;width:96%;">
              <div style="float:left;width:67%">
                <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px;margin-top:5px">{{ this.GetTraduzioneLabel('VUEPopupDatiStorici','TKN_POPUP_DATI_STORICI_ORIENT_ASSE_N',this.LinguaUtente) }}</label>
              </div> 
              <div style="float:left;width:33%">
                <input :disabled="OrientamentoDisabilitato" step="0.01" style="float:left;" type="number" class="form-control" v-model="Filtro.OrientamentoAsse"/>
              </div> 
            </div>
            <div style="clear:both;height:10px"></div>
          </div>

          <!-- <div v-if="ApparePeriodoMedia()">
            <div style="float:left;width:4%;">&nbsp;</div>
            <div style="float:left;width:96%;">
              <div style="float:left;width:75%">
                <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px;margin-top:5px">Periodo media</label>
              </div> 
              <div style="float:left;width:25%">
                <input style="float:left;" type="number" class="form-control" v-model="Filtro.PeriodoMedia"/>
              </div> 
            </div>
            <div class="ZMDistanziatore"></div>
          </div> -->

        </div>

        <div style="float:left;width:3%;">&nbsp;</div>

        <div style="clear:both;height:4px"></div>

      </div>


      <!-- <div style="width:40%;float:right" v-if="AppaionoAllineamenti()">
        <div class="col-md-12">

          <div style="float:left;width:3%;">&nbsp;</div>
          <div style="width:94%;float:left">
            <div class="ZMSeparatoreScheda" style="margin-bottom:0px;margin-top:0px" :style="{'background-color' : ColoriPantone.Marrone }">       
              <text style="font-weight: bold;">Allineamento inclinazioni alla data:</text>
            </div>
          </div>
          <div style="float:left;width:3%;">&nbsp;</div>
          <div class="ZMDistanziatore"></div>

          <div style="float:left;width:3%;">&nbsp;</div>
          <div style="width:94%;float:left" v-if="Filtro.AllineamentoIncl == null">
            <div style="margin-bottom:0px;margin-top:0px;text-align:center">       
              <text style="font-weight: bold">Non assegnato</text>
            </div>
          </div>
          <div style="width:94%;float:left" v-else>
            <div style="margin-bottom:0px;margin-top:0px;text-align:center">       
              <text style="font-weight: bold">{{ GestisciDateGrafica(Filtro.AllineamentoIncl.DataAllineamento) + ' ' + Filtro.AllineamentoIncl.OrarioAllineamento }}</text>
            </div>
          </div>
          <div style="float:left;width:3%;">&nbsp;</div>
          <div class="ZMDistanziatore"></div>

          <div style="float:left;width:3%;">&nbsp;</div>
          <div style="width:94%;float:left">
            <div style="margin-bottom:0px;margin-top:0px;text-align:center">       
              <button @click="OnClickCancellaAllineamentoInclinazioni" type="button" class="btn btn-info" style="float:right;font-weight:bold;width:20%" data-dismiss="modal">Annulla</button>
              <button @click="OnClickVisualizzaAllineamentoInclinazioniAllaData" type="button" class="btn btn-info" style="float:right;font-weight:bold;width:20%;margin-right:20px" data-dismiss="modal">Cambia</button>
            </div>
          </div>
          <div style="float:left;width:3%;">&nbsp;</div>
          <div class="ZMDistanziatore"></div>
        </div>

        <div class="col-md-12">
          <div style="float:left;width:3%;">&nbsp;</div>
          <div style="width:94%;float:left">
            <div class="ZMSeparatoreScheda" style="margin-bottom:0px;margin-top:0px" :style="{'background-color' : ColoriPantone.Marrone }">       
              <text style="font-weight: bold;">Allineamento temperatura alla data:</text>
            </div>
          </div>
          <div style="float:left;width:3%;">&nbsp;</div>
          <div class="ZMDistanziatore"></div>

          <div style="float:left;width:3%;">&nbsp;</div>
          <div style="width:94%;float:left" v-if="Filtro.AllineamentoTemp == null">
            <div style="margin-bottom:0px;margin-top:0px;text-align:center">       
              <text style="font-weight: bold">Non assegnato</text>
            </div>
          </div>
          <div style="width:94%;float:left" v-else>
            <div style="margin-bottom:0px;margin-top:0px;text-align:center">       
              <text style="font-weight: bold">{{ GestisciDateGrafica(Filtro.AllineamentoTemp.DataAllineamento) + ' ' + Filtro.AllineamentoTemp.OrarioAllineamento }}</text>
            </div>
          </div>
          <div style="float:left;width:3%;">&nbsp;</div>
          <div class="ZMDistanziatore"></div>

          <div style="float:left;width:3%;">&nbsp;</div>
          <div style="width:94%;float:left">
            <div style="margin-bottom:0px;margin-top:0px;text-align:center">       
              <button @click="OnClickCancellaAllineamentoTemp" type="button" class="btn btn-info" style="float:right;font-weight:bold;width:20%" data-dismiss="modal">Annulla</button>
              <button @click="OnClickVisualizzaAllineamentoTempAllaData" type="button" class="btn btn-info" style="float:right;font-weight:bold;width:20%;margin-right:20px" data-dismiss="modal">Cambia</button>
            </div>
          </div>
          <div style="float:left;width:3%;">&nbsp;</div>
          <div class="ZMDistanziatore"></div>
        </div>

        <div class="col-md-12">
          <div style="float:left;width:3%;">&nbsp;</div>
          <div style="width:94%;float:left">
            <div class="ZMSeparatoreScheda" style="margin-bottom:0px;margin-top:0px" :style="{'background-color' : ColoriPantone.Marrone }">       
              <text style="font-weight: bold;">Allineamento deformazioni alla data:</text>
            </div>
          </div>
          <div style="float:left;width:3%;">&nbsp;</div>
          <div class="ZMDistanziatore"></div>

          <div style="float:left;width:3%;">&nbsp;</div>
          <div style="width:94%;float:left" v-if="Filtro.AllineamentoDef == null">
            <div style="margin-bottom:0px;margin-top:0px;text-align:center">       
              <text style="font-weight: bold">Non assegnato</text>
            </div>
          </div>
          <div style="width:94%;float:left" v-else>
            <div style="margin-bottom:0px;margin-top:0px;text-align:center">       
              <text style="font-weight: bold">{{ GestisciDateGrafica(Filtro.AllineamentoDef.DataAllineamento) + ' ' + Filtro.AllineamentoDef.OrarioAllineamento }}</text>
            </div>
          </div>
          <div style="float:left;width:3%;">&nbsp;</div>
          <div class="ZMDistanziatore"></div>

          <div style="float:left;width:3%;">&nbsp;</div>
          <div style="width:94%;float:left">
            <div style="margin-bottom:0px;margin-top:0px;text-align:center">       
              <button @click="OnClickCancellaAllineamentoDeformazioni" type="button" class="btn btn-info" style="float:right;font-weight:bold;width:20%" data-dismiss="modal">Annulla</button>
              <button @click="OnClickVisualizzaAllineamentoDeformazioniAllaData" type="button" class="btn btn-info" style="float:right;font-weight:bold;width:20%;margin-right:20px" data-dismiss="modal">Cambia</button>
            </div>
          </div>
          <div style="float:left;width:3%;">&nbsp;</div>
          <div class="ZMDistanziatore"></div>
        </div>
      </div> -->


    </template>
   
    <template  v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:20%" @click="OnClickChiudiModal" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="CanRecord()" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:20%" @click="OnClickConfermaModal"  data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
 
  </VUEModal>
</template>

<script>

import VUEModal from '@/utils/VUEModal.vue';            
import { COLORI_PANTONE, SystemInformation, TIPOLOGIA_GRAFICI_STORICI, SFONDO, TInfoGraficiStorici, LOCALSTORAGE } from '@/SystemInformation'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import { TZDateFunct } from '@/utils/ZDateFunct.js'
import VUEPopupDataAllineamento from '../Popups/VUEPopupDataAllineamento.vue'
import MixInsDoubleClickHandler from '@/views/ContentPages/MixInsDoubleClickHandler';
export default 
{
  data()
  {
   return {
            ColoriPantone         : COLORI_PANTONE,
            ColoriSfondo          : SFONDO,
            TipologiaGrafici      : TIPOLOGIA_GRAFICI_STORICI,
            TipologiaPopup        : SystemInformation.TipoPopupAperto,
            Filtro                : {
                                      Piezometri           : false,
                                      Profondita           : false,
                                      Estensimetri         : false,
                                      AllaData             : '',
                                      OreDal               : 0,
                                      OreAl                : 23,
                                      DallaData            : '',
                                      DallaProfondita      : 0,
                                      AllaProfondita       : 0,
                                      VisualizzaMarkup     : false,
                                      InterpMinimiQuadrati : false,
                                      OrientamentoAsse     : null,
                                      PeriodoMedia         : 0,
                                      AllineamentoIncl     : null, 
                                      AllineamentoTemp     : null,
                                      AllineamentoDef      : null,
                                    },
            GrandezzaDivPulsanti  : {
                                      Height : 0
                                    },
            URLSchedaStorici      : '/appMainWindow/GraficiStorici',

            FiltroProfonditaAttivo        : false,
            PopupFiltroProfondita         : false,
            PopupAllineamentoInclinazioni : false,
            PopupAllineamentoTemp         : false,
            PopupAllineamentoDeformazioni : false,
            OrientamentoDisabilitato      : false,
            LinguaUtente                  : SystemInformation.UserInformation.Lingua
          }
  },

  props : ['AltezzaPopup', 'Titolo', 'ObjCatena', 'VettoreModuli'],
  emits : ['OnClickChiudiPopup'],
  mixins: [MixInsDoubleClickHandler, MixInsGestioneTraduzioni],
  components: { 
                VUEModal,
                VUEPopupDataAllineamento 
              },

  methods :
  {
    OnClickChiudiModal()
    {
      this.$emit('OnClickChiudiPopup')
    },


    OnClickVisualizzaAllineamentoInclinazioniAllaData()
    {
      this.PopupAllineamentoInclinazioni = true
    },
    OnClickConfermaAllineamento(OggettoData)
    {
      this.PopupAllineamentoInclinazioni = false
      this.Filtro.AllineamentoIncl       = OggettoData
    },
    OnClickAnnullaAllineamento()
    { 
      this.PopupAllineamentoInclinazioni = false
    },
    OnClickCancellaAllineamentoInclinazioni()
    {
      this.Filtro.AllineamentoIncl = null
    },


    OnClickVisualizzaAllineamentoTempAllaData()
    {
      this.PopupAllineamentoTemp = true
    },
    OnClickConfermaAllineamentoTemp(OggettoData)
    {
      this.PopupAllineamentoTemp   = false
      this.Filtro.AllineamentoTemp = OggettoData
    },
    OnClickAnnullaAllineamentoTemp()
    { 
      this.PopupAllineamentoTemp = false
    },
    OnClickCancellaAllineamentoTemp()
    {
      this.Filtro.AllineamentoTemp = null
    },


    OnClickVisualizzaAllineamentoDeformazioniAllaData()
    {
      this.PopupAllineamentoDeformazioni = true
    },
    OnClickConfermaAllineamentoDeformazioni(OggettoData)
    {
      this.PopupAllineamentoDeformazioni = false
      this.Filtro.AllineamentoDef        = OggettoData
    },
    OnClickAnnullaAllineamentoDeformazioni()
    { 
      this.PopupAllineamentoDeformazioni = false
    },
    OnClickCancellaAllineamentoDeformazioni()
    {
      this.Filtro.AllineamentoDef = null
    },


    OnClickConfermaModal()
    {
      let ModuliSelezionati = this.FiltraModuli.filter((element) => {return element.Selezionato})
      SystemInformation.OggettoInfoGraficiStorici = new TInfoGraficiStorici(this.ObjCatena.DatiCatena.CHIAVE_SITO, 
                                                                            this.ObjCatena.DatiCatena.CHIAVE,
                                                                            this.ObjCatena.Descrizione,
                                                                            this.TipologiaPopup,
                                                                            ModuliSelezionati, 
                                                                            new Date(this.Filtro.DallaData), 
                                                                            new Date(this.Filtro.AllaData), 
                                                                            this.Filtro.OreDal, 
                                                                            this.Filtro.OreAl,
                                                                            this.Filtro.VisualizzaMarkup,
                                                                            this.Filtro.InterpMinimiQuadrati,
                                                                            this.Filtro.OrientamentoAsse,
                                                                            this.Filtro.PeriodoMedia)
      
      if(this.Filtro.AllineamentoIncl != null)
        SystemInformation.OggettoInfoGraficiStorici.AllineamentoIncl     = this.Filtro.AllineamentoIncl
      if(this.Filtro.AllineamentoTemp != null)
        SystemInformation.OggettoInfoGraficiStorici.AllineamentoTemp     = this.Filtro.AllineamentoTemp
      if(this.Filtro.AllineamentoDef != null)
        SystemInformation.OggettoInfoGraficiStorici.AllineamentoDef      = this.Filtro.AllineamentoDef
      
      SystemInformation.OggettoInfoGraficiStorici.ListaFalde             = this.VettoreModuli.filter((element) => {return element.Piezometro})

      SystemInformation.OggettoInfoGraficiStorici.UrlRitornoAllaCatena   = this.$route.fullPath
      
      localStorage.removeItem(LOCALSTORAGE.OggettoInfoGraficiStorici);
      localStorage.setItem(LOCALSTORAGE.OggettoInfoGraficiStorici, JSON.stringify(SystemInformation.OggettoInfoGraficiStorici));

      this.$router.push(this.URLSchedaStorici)
    },

    OnClickSelezionaTuttiModuli()
    {
      if(this.FiltraModuli.length != 0)
      {
        this.FiltraModuli.forEach(function(Modulo)
        { 
            Modulo.Selezionato = true
        });
      }
    },

    OnClickDeselezionaTuttiModuli()
    {
      if(this.FiltraModuli.length != 0)
      {
        this.FiltraModuli.forEach(function(Modulo)
        { 
            Modulo.Selezionato = false
        });
      }
    },

    OnClickInvertiTuttiModuli()
    {
      if(this.FiltraModuli.length != 0)
      {
        this.FiltraModuli.forEach(function(Modulo)
        { 
            Modulo.Selezionato = !Modulo.Selezionato
        });
      }
    },

    OnClickPopupFiltroProfondita()
    {
      this.PopupFiltroProfondita = true
    },

    ConfermaFiltroProfondita()
    {
      this.Filtro.Profondita      = true
      this.FiltroProfonditaAttivo = true
      this.PopupFiltroProfondita  = false
    },

    AnnullaFiltroProfondita()
    {
      this.PopupFiltroProfondita = false
    },

    OnClickResetFiltroProfondita()
    {
      this.Filtro.DallaProfondita = 0
      this.Filtro.AllaProfondita  = 0
      this.Filtro.Profondita      = false
      this.FiltroProfonditaAttivo = false
    },

    CalcolaGrandezzaDivPulsanti()
    {
      this.GrandezzaDivPulsanti.Height = this.$refs.DivPulsanti.clientHeight
    },

    GetAWeekAgo()
    {
      var date = new Date();
      date.setDate(date.getDate() - 7);
      return date
    },

    ControlloDateInserite()
    {
      if(this.Filtro.DallaData != '' && this.Filtro.AllaData != '' && this.Filtro.OreDal !== '' && this.Filtro.OreAl !== '')
      {
        if(this.Filtro.DallaData + ' ' + this.Filtro.OreDal < this.Filtro.AllaData + ' ' + this.Filtro.OreAl)
          return true
      }
      return false
    },

    ControlloModuliSelezionati()
    {
      for(let i = 0; i < this.FiltraModuli.length; i++)
      {
        if(this.FiltraModuli[i].Selezionato)
          return true
      }
      return false
    },

    ControlloOrientamentoInserito()
    {
      if(this.TipologiaPopup == this.TipologiaGrafici.SPOSTAMENTI_GRAFICI_SEPARATI ||
         this.TipologiaPopup == this.TipologiaGrafici.SPOSTAMENTI_GRAFICI_SOVR ||
         this.TipologiaPopup == this.TipologiaGrafici.VELOCITA_MEDIA_ORARIA ||
         this.TipologiaPopup == this.TipologiaGrafici.VELOCITA_MEDIA_GIORNALIERA ||
         this.TipologiaPopup == this.TipologiaGrafici.ACCELERAZIONE_MEDIA_ORARIA ||
         this.TipologiaPopup == this.TipologiaGrafici.ACCELERAZIONE_MEDIA_GIORNALIERA)
         {
          if(this.Filtro.Piezometri || this.Filtro.Estensimetri)
          {
            this.OrientamentoDisabilitato = true
            // this.Filtro.OrientamentoAsse = ''
            return false
          }
          if((this.Filtro.OrientamentoAsse != null && this.Filtro.OrientamentoAsse != '') || this.Filtro.OrientamentoAsse === 0)
            return true
         }
      else return true
      return false
    },

    CanRecord()
    {
      return this.ControlloOrientamentoInserito() && 
             this.ControlloDateInserite() && 
             this.ControlloModuliSelezionati()
             
    },

    GestisciDateGrafica(Data)
    {
      return TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date(Data))
    },

    AppareCheckPiezometri()
    {
      return this.TipologiaPopup == this.TipologiaGrafici.CAMPIONI_RILEVATI ||
             this.TipologiaPopup == this.TipologiaGrafici.EV_ACCELEROMETRICI_SINTETICI_F ||
             this.TipologiaPopup == this.TipologiaGrafici.SPOSTAMENTI_GRAFICI_SEPARATI ||
             this.TipologiaPopup == this.TipologiaGrafici.SPOSTAMENTI_GRAFICI_SOVR ||
             this.TipologiaPopup == this.TipologiaGrafici.VELOCITA_MEDIA_ORARIA ||
             this.TipologiaPopup == this.TipologiaGrafici.VELOCITA_MEDIA_GIORNALIERA ||
             this.TipologiaPopup == this.TipologiaGrafici.ACCELERAZIONE_MEDIA_ORARIA ||
             this.TipologiaPopup == this.TipologiaGrafici.ACCELERAZIONE_MEDIA_GIORNALIERA
    },

    AppareCheckEstensimetri()
    {
      return this.TipologiaPopup == this.TipologiaGrafici.CAMPIONI_RILEVATI ||
             this.TipologiaPopup == this.TipologiaGrafici.EV_ACCELEROMETRICI_SINTETICI_F ||
             this.TipologiaPopup == this.TipologiaGrafici.SPOSTAMENTI_GRAFICI_SEPARATI ||
             this.TipologiaPopup == this.TipologiaGrafici.SPOSTAMENTI_GRAFICI_SOVR ||
             this.TipologiaPopup == this.TipologiaGrafici.VELOCITA_MEDIA_ORARIA ||
             this.TipologiaPopup == this.TipologiaGrafici.VELOCITA_MEDIA_GIORNALIERA ||
             this.TipologiaPopup == this.TipologiaGrafici.ACCELERAZIONE_MEDIA_ORARIA ||
             this.TipologiaPopup == this.TipologiaGrafici.ACCELERAZIONE_MEDIA_GIORNALIERA
    },

    AppareCheckVisualizzaMarkup()
    {
      return this.TipologiaPopup == this.TipologiaGrafici.CAMPIONI_RILEVATI
    },

    AppareCheckInterpMinQuad()
    {
      return this.TipologiaPopup == this.TipologiaGrafici.CAMPIONI_RILEVATI ||
             this.TipologiaPopup == this.TipologiaGrafici.SPOSTAMENTI_GRAFICI_SEPARATI ||
             this.TipologiaPopup == this.TipologiaGrafici.VELOCITA_MEDIA_ORARIA ||
             this.TipologiaPopup == this.TipologiaGrafici.VELOCITA_MEDIA_GIORNALIERA ||
             this.TipologiaPopup == this.TipologiaGrafici.ACCELERAZIONE_MEDIA_ORARIA ||
             this.TipologiaPopup == this.TipologiaGrafici.ACCELERAZIONE_MEDIA_GIORNALIERA
    },

    AppareOrientamentoAsse()
    {
      return this.TipologiaPopup == this.TipologiaGrafici.SPOSTAMENTI_GRAFICI_SEPARATI ||
             this.TipologiaPopup == this.TipologiaGrafici.SPOSTAMENTI_GRAFICI_SOVR ||
             this.TipologiaPopup == this.TipologiaGrafici.VELOCITA_MEDIA_ORARIA ||
             this.TipologiaPopup == this.TipologiaGrafici.VELOCITA_MEDIA_GIORNALIERA ||
             this.TipologiaPopup == this.TipologiaGrafici.ACCELERAZIONE_MEDIA_ORARIA ||
             this.TipologiaPopup == this.TipologiaGrafici.ACCELERAZIONE_MEDIA_GIORNALIERA
    },

    ApparePeriodoMedia()
    {
      return this.TipologiaPopup == this.TipologiaGrafici.CAMPIONI_RILEVATI ||
             this.TipologiaPopup == this.TipologiaGrafici.SPOSTAMENTI_GRAFICI_SEPARATI ||
             this.TipologiaPopup == this.TipologiaGrafici.VELOCITA_MEDIA_ORARIA ||
             this.TipologiaPopup == this.TipologiaGrafici.VELOCITA_MEDIA_GIORNALIERA ||
             this.TipologiaPopup == this.TipologiaGrafici.ACCELERAZIONE_MEDIA_ORARIA ||
             this.TipologiaPopup == this.TipologiaGrafici.ACCELERAZIONE_MEDIA_GIORNALIERA
    },

    AppaionoAllineamenti()
    {
      return this.TipologiaPopup == this.TipologiaGrafici.CAMPIONI_RILEVATI
    },
  },
  
  computed:
  {
    FiltraModuli :
    {
      get()
      {
        let Self   = this
        let Result = []
        Result     = this.VettoreModuli
        if(this.Filtro.Estensimetri || this.Filtro.Piezometri || this.Filtro.Profondita)
        {
          Result = Result.filter(function(Modulo)
          {
            let ProfonditaModulo  = parseFloat(Modulo.Profondita)
            let ProfonditaMinima  = parseFloat(Self.Filtro.DallaProfondita)
            let ProfonditaMassima = parseFloat(Self.Filtro.AllaProfondita)
            if(Self.Filtro.Piezometri && Modulo.Piezometro)
              return true
            if(Self.Filtro.Estensimetri && Modulo.Estensimetro)
              return true
            if(Self.Filtro.Profondita && (ProfonditaMassima < ProfonditaMinima) && (ProfonditaMassima <= ProfonditaModulo) && (ProfonditaModulo <= ProfonditaMinima))
              return true
            if(Self.Filtro.Profondita && (ProfonditaMinima < ProfonditaMassima) && (ProfonditaMinima <= ProfonditaModulo)  && (ProfonditaModulo <= ProfonditaMassima))
              return true
            return false
          })
        }

        return Result
      }
    }
  },

  beforeMount()
  {
    this.Filtro.AllaData  = TZDateFunct.FormatDateTime('yyyy-mm-dd',new Date())
    this.Filtro.DallaData = TZDateFunct.FormatDateTime('yyyy-mm-dd',this.GetAWeekAgo())
  },

  mounted()
  {
    this.CalcolaGrandezzaDivPulsanti()
  },

  watch:
  {
    'Filtro.OrientamentoAsse': 
      function (newValue) 
      {
        if(newValue != '')
        {
          if (isNaN(newValue)) 
            this.Filtro.OrientamentoAsse = 0;
          else this.Filtro.OrientamentoAsse = Math.max(0, Math.min(359.99, parseFloat(newValue)));
        }
      },
      
    FiltraModuli:
    {
      handler(NewValue)
      {
        if(NewValue != '')
        {
          if(this.TipologiaPopup == this.TipologiaGrafici.SPOSTAMENTI_GRAFICI_SEPARATI ||
            this.TipologiaPopup == this.TipologiaGrafici.SPOSTAMENTI_GRAFICI_SOVR ||
            this.TipologiaPopup == this.TipologiaGrafici.VELOCITA_MEDIA_ORARIA ||
            this.TipologiaPopup == this.TipologiaGrafici.VELOCITA_MEDIA_GIORNALIERA ||
            this.TipologiaPopup == this.TipologiaGrafici.ACCELERAZIONE_MEDIA_ORARIA ||
            this.TipologiaPopup == this.TipologiaGrafici.ACCELERAZIONE_MEDIA_GIORNALIERA)
          {            
            if(this.Filtro.Piezometri || this.Filtro.Estensimetri)
              this.OrientamentoDisabilitato = true
            else this.OrientamentoDisabilitato = false
          }
        }
      },
      deep : true
    }
  },
  
}
</script>